import memoizeOne from 'memoize-one';
import { SearchResultsListItemScope } from '../components';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { MagicSearchPluginSync, MagicSearchPluginName, ResultItem } from './types';

export type SearchScope = {
  id: string;
  title: string;
  icon: FontAwesomeIconProps['icon'];
};

function startsWithTrigger(searchText: string, trigger: string) {
  for (let i = 0; i < trigger.length; i++) {
    if (searchText.startsWith(trigger.substring(0, i + 1))) {
      return true;
    }
  }
  return false;
}

const createScopesWithTrigger = memoizeOne((indexItems: SearchScope[], trigger: string) =>
  indexItems.map(scope => ({ ...scope, trigger: trigger + scope.title })),
);

// Regular expression to match strings starting with "i", "in", or "in:"
// const regex = /^i?n?:?/;

// Scopes can be 'project' | 'config' | 'etc...', so the user can write in:project, in:config, etc
// this can be used later to interact with other plugins and make the search in one specific scope.
// For example in:project search everything only inside the current project.
const scopeSearchPlugin = ({
  headerTitle,
  trigger = 'in:',
  hint = 'in:...',
  scopes,
}: {
  headerTitle?: string;
  trigger?: string;
  hint?: string;
  scopes: SearchScope[];
}): MagicSearchPluginSync => {
  const scopesWithTrigger = createScopesWithTrigger(scopes, trigger);

  return {
    name: MagicSearchPluginName.ScopeSearchPlugin,
    hint: ({ searchScopes }) => (!searchScopes.some(scope => scope.id === 'project') ? hint : null),
    onSearch: ({ searchText, searchScopes }) => {
      if (searchText && !startsWithTrigger(searchText, trigger)) return [];

      const filteredScopesWithTrigger = scopesWithTrigger.filter(
        ({ id, trigger }) =>
          !searchScopes.some(scope => scope.id === id) && trigger.startsWith(searchText),
      );

      if (!filteredScopesWithTrigger.length) return [];

      const results: ResultItem[] = [];

      results.push(
        ...filteredScopesWithTrigger.map(scope => ({
          id: scope.id,
          Component: SearchResultsListItemScope,
          props: {
            scope,
            type: headerTitle,
          },
        })),
      );

      return results;
    },
  };
};

export { scopeSearchPlugin };
